module.exports = __webpack_public_path__ + "medical-and-health.6c7037af622e07b23bd5.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/medical/webfont/medical-and-health.woff
// module id = ../../../../../src/assets/fonts/line-icons-pro/medical/webfont/medical-and-health.woff
// module chunks = styles